'use strict';

module.exports = [
	{
		name: 'BLANK_PROJECT',
		url: '246758991'
	},
	{
		name: 'PRISON_ESCAPE',
		url: '248177069',
		tutorialId: 'prison-escape'
	},
	{
		name: 'BARREL_ROLL',
		url: '247497411',
		tutorialId: 'barrel-roll'
	},
	{
		name: 'BARREL_ROLL_TRAILER',
		url: '245741513',
		tutorialId: 'barrel-roll'
	},
	{
		name: 'SNOWCLONES',
		url: '251493734',
		tutorialId: 'snowclones'
	},
	{
		name: 'SNOWCLONES_TRAILER',
		url: '246296090',
		tutorialId: 'snowclones'
	},
	{
		name: 'STRANGER_HILL',
		url: '262986061',
		tutorialId: 'stranger-hill'
	},
	{
		name: 'STRANGER_HILL_TRAILER',
		url: '262990282',
		tutorialId: 'stranger-hill'
	},
	{
		name: 'TERRAIN_TOOLS',
		url: '263869461',
		tutorialId: 'terrain-tools'
	},
	{
		name: 'BOX_CAR_RACER_TRAILER',
		url: '268980694',
		tutorialId: 'box-car-racer'
	},
	{
		name: 'BOX_CAR_RACER',
		url: '269007549',
		tutorialId: 'box-car-racer'
	},
	{
		name: 'TERRAIN_TOOLS_TRAILER',
		url: '263304427',
		tutorialId: 'terrain-tools'
	},
	{
		name: 'NIGHTLIGHTS_TRAILER',
		url: '264040704',
		tutorialId: 'nightlights'
	},
	{
		name: 'MUSIC_ROOM',
		url: '266126536',
		tutorialId: 'music-room'
	},
	{
		name: 'MUSIC_ROOM_TRAILER',
		url: '265197792',
		tutorialId: 'music-room'
	},
	{
		name: 'CLEAN_SLATE',
		url: '268559740',
		tutorialId: 'clean-slate'
	},
	{
		name: 'CLEAN_SLATE_TRAILER',
		url: '266647805',
		tutorialId: 'clean-slate'
	},
	{
		name: 'NIGHTLIGHTS',
		url: '264991123',
		tutorialId: 'nightlights'
	},
	{
		name: 'ALIEN_ATTACK',
		url: '251496245',
		tutorialId: 'alien-attack'
	},
	{
		name: 'ALIEN_ATTACK_TRAILER',
		url: '245740756',
		tutorialId: 'alien-attack'
	},
	{
		name: 'NINJA_OBBY',
		url: '252557811',
		tutorialId: 'ninja-obby'
	},
	{
		name: 'NINJA_OBBY_TRAILER',
		url: '245740778',
		tutorialId: 'ninja-obby'
	},
	{
		name: 'WRESTLEBALL',
		url: '246124283',
		tutorialId: 'wrestleball'
	},
	{
		name: 'WRESTLEBALL_TRAILER',
		url: '246124120',
		tutorialId: 'wrestleball'
	},
	{
		name: 'RIDDLE_RUINS',
		url: '252188981',
		tutorialId: 'riddle-ruins'
	},
	{
		name: 'RIDDLE_RUINS_TRAILER',
		url: '245740809',
		tutorialId: 'riddle-ruins'
	},
	{
		name: 'ZOMBIE_SMASH',
		url: '251673819',
		tutorialId: 'zombie-smash'
	},
	{
		name: 'ZOMBIE_SMASH_TRAILER',
		url: '246292067',
		tutorialId: 'zombie-smash'
	},
	{
		name: 'GAME_DEV_TYCOON',
		url: '253991026',
		tutorialId: 'game-dev-tycoon'
	},
	{
		name: 'GAME_DEV_TYCOON_TRAILER',
		url: '246297944',
		tutorialId: 'game-dev-tycoon'
	},
	{
		name: 'PLATFORM_GAME_DESIGN',
		url: '247934934',
		tutorialId: 'platform-game-design'
	},
	{
		name: 'PLATFORM_GAME_DESIGN_TRAILER',
		url: '245742904',
		tutorialId: 'platform-game-design'
	},
	{
		name: 'GOAL_IN_ONE_TRAILER',
		url: '277457418',
		tutorialId: 'goal-in-one'
	},
	{
		name: 'GOAL_IN_ONE',
		url: '276213556',
		tutorialId: 'goal-in-one'
	},
	{
		name: 'TREASURE_ISLAND',
		url: '269895390',
		tutorialId: 'treasure-island'
	},
	{
		name: 'TREASURE_ISLAND_TRAILER',
		url: '272583426',
		tutorialId: 'treasure-island'
	},
	{
		name: 'PUBLISHING_PRO',
		url: '273665009',
		tutorialId: 'publishing-pro'
	},
	{
		name: 'PUBLISHING_PRO_TRAILER',
		url: '276194554',
		tutorialId: 'publishing-pro'
	},
	{
		name: 'EPIC_PRISON_ESCAPE',
		url: '282646533',
		tutorialId: 'epic-prison-escape'
	},
	{
		name: 'EPIC_PRISON_ESCAPE_TRAILER',
		url: '283422557',
		tutorialId: 'epic-prison-escape'
	},
	{
		name: 'MARKETING_CRASH_COURSE',
		url: '272787174',
		tutorialId: 'marketing-crash-course'
	},
	{
		name: 'MARKETING_CRASH_COURSE_TRAILER',
		url: '276194514',
		tutorialId: 'marketing-crash-course'
	},
	{
		name: 'PICNIC_PINBALL',
		url: '278444333',
		tutorialId: 'picnic-pinball'
	},
	{
		name: 'PICNIC_PINBALL_TRAILER',
		url: '277252058',
		tutorialId: 'picnic-pinball'
	}
];
